export default "__VITE_ASSET__iQ618SN3__"